export default function HowItWorks({onRef}) {
  return (
    <div className="fast-easy how-it-works" ref={onRef}>
      <h2>How Trademark Genius Works</h2>
      <h3>Get your trademark registered in just 3 easy steps using our simple online questionaire.</h3>
      <div className="wrapper">
        <div className="fast-box">
          <div className="shield-box">1</div>
          <p className="orange">Complete Our Online Questionnaire</p>
          <p>All information gathered is confidential and secured.</p>
        </div>
        <div className="arrow"></div>
        <div className="fast-box">
          <div className="shield-box">2</div>
          <p className="orange">We Review & Prepare the Application for Submission</p>
          <p>
            Our specialists review for any missing information, conduct a Direct-Hit search and ensure the application
            is ready for quick and easy processing.
          </p>
        </div>
        <div className="arrow"></div>
        <div className="fast-box">
          <div className="shield-box">3</div>
          <p className="orange">Application is Filed</p>
          <p>
            The application is electronically with filed the USPTO for examination. You will be notified with all status
            updates and additional handling.
          </p>
        </div>
      </div>
    </div>
  );
};
